import React__default, { useCallback } from 'react';
import { ThemeName } from '@sravni/design-system-theme';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Theme, Sun } from '@sravni/react-icons';
import { useStyles, useTheme } from '@sravni/react-utils';
import modules_8bb178ca from '../styles/ThemeSwitcher.module.less.js';

/**
 * @description ThemeSwitcher component.
 *
 * @component
 * @example
 * ```jsx
 * <ThemeSwitcher / >
 * ```
 */
const ThemeSwitcher = React__default.forwardRef((props, ref) => {
    const { className, onClick, ...rest } = props;
    const cx = useStyles(modules_8bb178ca);
    const [theme, setTheme] = useTheme();
    const handleThemeChange = useCallback(() => {
        const themeToSet = theme === ThemeName.lager ? ThemeName.guinness : ThemeName.lager;
        onClick?.(themeToSet);
        setTheme(themeToSet);
    }, [onClick, setTheme, theme]);
    return (React__default.createElement("div", { ref: ref, "data-qa": "ThemeSwitcher", className: cx(className, 'container'), ...rest },
        React__default.createElement(Icon, { size: 16, shape: "round", className: cx('h-cursor-pointer', 'iconWrapper'), onClick: handleThemeChange, background: "dark" },
            React__default.createElement(Theme, { className: cx('icon', { bounceIn: theme === ThemeName.guinness, bounceOut: theme === ThemeName.lager }) }),
            React__default.createElement(Sun, { className: cx('icon', { bounceOut: theme === ThemeName.guinness, bounceIn: theme === ThemeName.lager }) }))));
});
ThemeSwitcher.displayName = 'ThemeSwitcher';

export { ThemeSwitcher };
//# sourceMappingURL=ThemeSwitcher.js.map
